export type VehicleEstado = 'Disponible' | 'Vendido'

export interface Vehicle {
  id: string
  marca: string
  modelo: string
  anio: string
  combustible: string
  km?: string
  color?: string
  precioArs?: string
  precioUsd?: string
  estado: VehicleEstado
  fotos: string[]
  equipamiento?: string
}

export const MARCAS = [
  'BMW',
  'Chevrolet',
  'Citroën',
  'Fiat',
  'Ford',
  'Honda',
  'Hyundai',
  'Jeep',
  'Kia',
  'Nissan',
  'Peugeot',
  'Renault',
  'Suzuki',
  'Toyota',
  'Volkswagen',
  'Otras',
]

export const ANIOS = [
  '2026',
  '2025',
  '2024',
  '2023',
  '2022',
  '2021',
  '2020',
  '2019',
  '2018',
  '2017',
  '2016',
  '2015',
  '2014',
  '2013',
  '2012',
  '2011',
  '2010',
  '2009',
  '2008',
  '2007',
  '2006',
  '2005',
  '2004',
  '2003',
]

export const COMBUSTIBLES = ['Nafta', 'Nafta/GNC', 'GNC', 'Diésel', 'Híbrido']
